import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Modal, Row } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import AddOrEditAssignment from '../../AddOrEditAssignment';

const ExerciseForStudent = ({ exerciseModalVisible, setExerciseModalVisible, selectedFolderId, worksheetFile }) => {
  const submitRef = React.useRef();

  return (
    <div>
      <Modal
        width='95%'
        style={{ marginTop: 24 }}
        centered
        className='exerciseForStudentModal'
        visible={exerciseModalVisible}
        title={worksheetFile.tags ? 'GIAO BÀI TẬP CHẤM TỰ ĐỘNG' : 'GIAO BÀI NHANH'}
        onCancel={() => {
          setExerciseModalVisible(false);
        }}
        footer={[
          <Button
            key='submit'
            type='primary'
            icon={<SaveOutlined />}
            onClick={() => {
              const IsValid = submitRef.current.submit();
              if (IsValid) {
                setTimeout(() => {
                  setExerciseModalVisible(false);
                }, 1200);
              }
            }}
          >
            Giao bài tập
          </Button>,
        ]}
      >
        <Row gutter={[16, 16]} style={{ overflowY: 'auto', height: '75vh' }}>
          <Col span={24} md={12} lg={14} xl={16}>
            <AddOrEditAssignment entityId={selectedFolderId} worksheetFile={worksheetFile} submitRef={submitRef} />
          </Col>
          <Col span={24} md={12} lg={10} xl={8}>
            <img className="d-none d-md-block" src={worksheetFile?.imgURL} alt='' style={{ width: '100%' }} />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

ExerciseForStudent.propTypes = {
  exerciseModalVisible: PropTypes.bool.isRequired,
  setExerciseModalVisible: PropTypes.func.isRequired,
  selectedFolderId: PropTypes.any.isRequired,
  worksheetFile: PropTypes.any.isRequired,
};

export default ExerciseForStudent;
